import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
} from "@material-ui/core";
import React from "react";

export function SportsDetails(props) {
  const { data } = props;
  const sportsData = {
    rankingsBestCollegeAthletics: {
      title: "Rankings Best College Athletics",
      value:
        data.rankingsBestCollegeAthletics &&
        data.rankingsBestCollegeAthletics.value
          ? data.rankingsBestCollegeAthletics.value
          : null,
    },
    rankingsBestStudentAthlete: {
      title: "Rankings Best Student Athletes",
      value:
        data.rankingsBestStudentAthlete && data.rankingsBestStudentAthlete.value
          ? data.rankingsBestStudentAthlete.value
          : null,
    },
    athleticConference: {
      title: "Athletic Conference",
      value: data.athleticConference,
    },
    athleticsMascot: {
      title: "Athletics Mascot",
      value: data.athleticsMascot,
    },
    menVarsitySports: {
      title: "Men Varsity Sports",
      value: data.menVarsitySports,
    },
    womenVarsitySports: {
      title: "Momen Varsity Sports",
      value: data.womenVarsitySports,
    },
  };

  return (
    <Card className="pt-5 px-5">
      <CardHeader title="Sports"></CardHeader>
      <CardContent>
        <Grid container spacing={5}>
          <Grid item sm>
            <Box>
              <List>
                {[
                  "rankingsBestCollegeAthletics",
                  "rankingsBestStudentAthlete",
                  "athleticConference",
                  "athleticsMascot",
                  "menVarsitySports",
                  "womenVarsitySports",
                ].map((keyName, index) => (
                  <Box key={index}>
                    <ListItem>
                      <ListItemText>
                        <Typography>{sportsData[keyName].title}</Typography>
                      </ListItemText>
                      <ListItemSecondaryAction
                        style={{ width: 200, textAlign: "right" }}
                      >
                        <Box textOverflow="ellipsis" overflow="hidden">
                          <Typography>
                            {sportsData[keyName].value
                              ? Array.isArray(sportsData[keyName].value)
                                ? sportsData[keyName].value
                                    .slice(0, 2)
                                    .join(", ")
                                : sportsData[keyName].value
                              : "--"}
                          </Typography>
                        </Box>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </Box>
                ))}
              </List>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
